import { useChangeVisibilityForVerkaeuferMutation } from '../../../api/AuftragAPI';

interface ThisProps {
  uidAuftrag: string;
  visibility: boolean;
  onClick: () => void;
}

/**
 * @author noone
 */
const ButtonAuftragHideComponent: React.FC<ThisProps> = (props) => {

  const [changeVisibilityAPI] = useChangeVisibilityForVerkaeuferMutation();

  const handleVisibilityChange = (uid: string, visible: boolean) => {
    if (!visible && !window.confirm("Möchten Sie diesen Auftrag wirklich ausblenden?")) return;

    changeVisibilityAPI({ uid, visible }).unwrap()
      .then(() => {
        props.onClick();
      })
      .catch((error) => console.log(error))
      ;

  }

  return (
    <>
      <button title={ props.visibility ? "Ausblenden" : "Sichbar machen"} className="btn btn-outline-secondary" onClick={() => handleVisibilityChange(props.uidAuftrag, !props.visibility)}>
        <i title={ props.visibility ? "Ausblenden" : "Sichbar machen"} style={{ cursor: "pointer", fontSize: "18pt" }} className={"bi "+ (props.visibility ? "bi-eye-slash" : "bi-eye")}></i>
      </button>
    </>
  );

}

export default ButtonAuftragHideComponent;